import script from "./ChipCost.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipCost.vue?vue&type=script&setup=true&lang=js"

import "./ChipCost.vue?vue&type=style&index=0&id=f19176e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f19176e8"]])

export default __exports__